import { render, staticRenderFns } from "./PersonalizedEdit.vue?vue&type=template&id=3fb0681b&"
import script from "./PersonalizedEdit.vue?vue&type=script&lang=js&"
export * from "./PersonalizedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalizedEdit.vue"
export default component.exports